<template>
  <main-layout>
    <div>
      <div class="jumbotron" id="jumbohead">
        <h2 class="display-5">{{getLCData.name}}</h2>
        <div id="myProgress">
          <div id="myBar" v-bind:style="{ width: getElements() }"></div>
        </div>
      </div>
      </div>
      <course-navigation :LCData='getLCData' :UserSubmissionData='getUserSubmissions()'></course-navigation>
        <!--<div class="col-lg-12">-->
          <div class="content">
            <router-view :UserSubmissionData='getUserSubmissions()'></router-view>
          </div>
        <!--</div>-->
      </div>
    </div>
  </main-layout>
</template>

<script>
import CourseNavigation from './CourseNavigation.vue'
import MainLayout from '../MainLayout.vue'
import { store } from '../../store/store.js'
import { dbSubmissionsRef } from '../../firebaseConfig'

export default {
    data() {
        return {
        wProgress: '1%',
        }
    },
    components: {
        CourseNavigation,
        MainLayout
    },
    computed: {
      getLCData() {
        //console.log(parseInt(this.$route.params.courseId))
        //var chapterId = parseInt(this.$route.params.chapterId);
        var courseId = parseInt(this.$route.params.courseId)
        return this.$store.getters.getCurrentLCData2(courseId)
      },
      getSubmissions() {
        return this.$store.getters.getSubmission2
      },
      currentUser(){
        return this.$store.getters.currentUser;
      },
    },
    methods: {
      getUserSubmissions(){
        var submissions = this.getSubmissions;
        if(submissions){
          // console.log("submissions")
          // console.log(submissions)
          // console.log("this.$store.getters.getSubmission2")
          // console.log(this.$store.getters.getSubmission2)
              var userSubmission = submissions.filter( submission => {
              return  (submission.lCId == this.getLCData.id && submission.userId == this.currentUser.uid );
          });
          //console.log("userSubmission3")
          //console.log(userSubmission)
          
          return userSubmission
        }
      },
      getElements(){
        var submissions = this.getSubmissions;
        if(submissions){
          var userSubmission = submissions.filter( submission => {
              return  (submission.lCId == this.getLCData.id && submission.userId == this.currentUser.uid );
          });

          var LcCHapter = this.getLCData.chapter 
          
          var cp = 0
          for (var i = 0; i < LcCHapter.length; i++) {
            cp = cp +LcCHapter[i].assignmentPoints
          }

          var cCp = 1
          for (var i = 0; i < userSubmission.length; i++) {
            cCp = cCp +LcCHapter[i].assignmentPoints
          }

          var pProgress = (cCp/cp)*100+'%'
          //this.wProgress= pProgress+'%'
          return pProgress
        }
      }
    },
  created() {
    this.$store.dispatch('setSubmissionRef', dbSubmissionsRef);
  },
}
</script>

<style scoped>
  .content{
    padding-top:0px;
    padding-bottom:20px;
  }
  /** >>> this will affect the child component **/
  main{
    box-shadow: 5px 5px 25px 0px rgba(46, 61, 73, 0.2); background-color: white;
  }
  .jumbotron{
    background: linear-gradient(-90deg, #26AAb2, #53D1AF);
    color: white;
    border-radius: .3rem .3rem 0 0;
  }
  
#myProgress {
  margin: 0 14em 0 14em;
  background-color: rgba(255,255,255,.3);
}
#myBar {
    width: 20%;
    height: 0.5em;
    background-color: white;
    color: #6AD5BF;
    font-weight:400;
    
}
  
@media (max-width: 575px) {
  h2{
    font-size:1.5em;
  }
  #myBar {
    height: 0.25em;
  }
  #myProgress {
    margin: 0 6em 0 6em;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/course/Course.vue